import React from 'react';
import { useSalesChannelType } from 'src/constrains/SalesChannelHOC/useSalesChannel';
import NativeContentPage from './index.old';
import { ChannelType, WebSiteSubType } from 'src/types/common/SalesChannel';
import { currentSelectedStyle } from 'src/constrains/SalesChannelStyleSelect/slice';
import { useSelector } from 'react-redux';
import EditorPage from 'src/pages/SalesChannelContentEditor/SalesChannelContentPage/EditorPage-revamp';

const HomepageJunction = (props) => {
  const type = useSalesChannelType();
  const isMini = type === ChannelType.MiniProgram;
  const isNative =
    useSelector(currentSelectedStyle()) === WebSiteSubType.NativeMobile;
  return isMini || isNative ? (
    <NativeContentPage {...props} />
  ) : (
    <EditorPage {...props} />
  );
};
export default HomepageJunction;
